/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2022 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */

/**
 * The Interrupted Event.
 *
 * @event SpinePluginEvents#INTERRUPTED
 * @since 3.19.0
 */
module.exports = 'interrupted';
